import * as E from "~/renderer/web-components/element";
import * as S from "~/styles/sfml.css";

export class CollapsibleLayout extends E.SFMLElement {
  private titleText: string | null = null;
  private exposedTitleText: string | null = null;
  private iconUrl: string | null = null;

  private readonly titleElement: HTMLElement;
  private readonly iconElement: HTMLElement;
  private readonly slotContainerElement: HTMLElement;
  private readonly headerElement: HTMLElement;

  private _exposed = false;

  public get exposed(): boolean {
    return this._exposed;
  }

  static observedAttributes = ["title", "exposed-title", "icon", "icon-url"];

  private draw() {
    if (!this.exposed) {
      this.titleElement.textContent = this.titleText;
    } else {
      this.titleElement.textContent = this.exposedTitleText;
    }
  }

  attributeChangedCallback(attr: string, oldValue: string | null, newValue: string | null) {
    switch (attr) {
      case "title": {
        this.titleText = newValue;
        this.draw();
        break;
      }
      case "exposed-title": {
        this.exposedTitleText = newValue;
        this.draw();
        break;
      }
      case "icon-url": {
        this.iconUrl = newValue;
        if (this.iconUrl) {
          const iconImageElement = document.createElement("img");
          iconImageElement.setAttribute("src", this.iconUrl);
          this.iconElement.appendChild(iconImageElement);
        } else if (this.iconElement.firstChild) {
          this.iconElement.removeChild(this.iconElement.firstChild);
        }
      }
    }
  }

  constructor() {
    super();

    this.headerElement = document.createElement("div");
    this.headerElement.className = S.header;

    const headerContainerElement = document.createElement("div");
    headerContainerElement.className = S.headerContainer;
    this.headerElement.appendChild(headerContainerElement);

    this.iconElement = document.createElement("span");
    this.iconElement.className = S.icon;
    this.titleElement = document.createElement("span");
    this.titleElement.className = S.title;

    headerContainerElement.appendChild(this.iconElement);
    headerContainerElement.appendChild(this.titleElement);

    this.slotContainerElement = document.createElement("div");
    const slot = document.createElement("div");
    this.addSlot(slot);
    this.slotContainerElement.appendChild(slot);
    this.slotContainerElement.style.display = "none";

    this.appendChildToShadow(this.headerElement);
    this.appendChildToShadow(this.slotContainerElement);
  }

  private onHeaderClickHandler = (e: Event) => {
    if (this.exposed === false) {
      this.slotContainerElement.style.display = "block";
      E.AspectResizer.shared.resize(this);

      const childElements = this.slotContainerElement.getElementsByTagName("*");
      for (let i = 0; i < childElements.length; i++) {
        const child = childElements[i];
        if (child instanceof E.SFMLCullingElement) {
          child.handleVisible();
        }
      }

      this._exposed = true;

      if (this.getAttribute("collapse-type") === "replace") {
        this.headerElement.style.display = "none";
      }
    } else {
      this.slotContainerElement.style.display = "none";
      this._exposed = false;
    }

    this.draw();
  };

  connectedCallback() {
    this.headerElement.addEventListener("click", this.onHeaderClickHandler);
  }

  disconnectedCallback() {
    this.headerElement.removeEventListener("click", this.onHeaderClickHandler);
  }
}
customElements.define("sfml-collapsible-layout", CollapsibleLayout);



// WEBPACK FOOTER //
// webpack://SFMLWeb/src/renderer/web-components/layout/collapsible.ts